var indentation_default = {
  "indentZero": "IS0gH",
  "indentOne": "OvMEF",
  "indentTwo": "-bGXW",
  "indentThree": "Sd6d1",
  "indentFour": "TBf9T",
  "indentFive": "d7RFK",
  "indentSix": "ZX-2D"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
